import React from "react";

import {Wrapper, Content}from './Body.styles'

const Body = ({header,children}) => (

<Wrapper>
    <h3>{header}</h3>
    <Content>
        {children}
    </Content>
</Wrapper>


);

export default Body;